import { Menu, useGetPermissions } from "react-admin";
import SettingsIcon from "@mui/icons-material/Settings";
import CodeIcon from "@mui/icons-material/Code";
import { useEffect, useState } from "react";

export const AppMenu = () => {
    let getPermissions = useGetPermissions();
    let [hasFullCMSAccess, setHasFullCMSAccess] = useState(false);

    useEffect(() => {
        getPermissions().then((permissions) => {
            console.log(permissions);
            setHasFullCMSAccess(permissions !== "cms_external");
        });
    }, [getPermissions]);

    console.log(hasFullCMSAccess);
    return hasFullCMSAccess ? (
        <Menu>
            <Menu.DashboardItem />
            <Menu.ResourceItems />
            <Menu.Item to="/featured_tracks" primaryText="Featured Tracks" leftIcon={<SettingsIcon />} />
            <Menu.Item to="/featured_artists" primaryText="Featured Artists" leftIcon={<SettingsIcon />} />
            <Menu.Item to="/curated_tracks" primaryText="Curated Tracks" leftIcon={<SettingsIcon />} />
            <Menu.Item to="/config" primaryText="Config" leftIcon={<SettingsIcon />} />
            <Menu.Item to="/json-import" primaryText="JSON Import" leftIcon={<CodeIcon />} />
            <Menu.Item to="/llm-import" primaryText="LLM Import (DJ set)" leftIcon={<CodeIcon />} />
        </Menu>
    ) : (
        <Menu>
            <Menu.DashboardItem />
            <Menu.ResourceItems />
        </Menu>
    );
};
